import { render, staticRenderFns } from "./AttentionDetection.vue?vue&type=template&id=1c3f5593&scoped=true"
import script from "./AttentionDetection.vue?vue&type=script&lang=js"
export * from "./AttentionDetection.vue?vue&type=script&lang=js"
import style0 from "./AttentionDetection.vue?vue&type=style&index=0&id=1c3f5593&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f5593",
  null
  
)

export default component.exports